import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import { URLParams, URLParamsToObject, formatDate, mobileVerify, request } from 'app/utils';
import { AuthApiResponse, useAuth } from 'features/auth';
import { useSchool } from 'features/school';
import { Loading } from 'components';

interface ValidateTokenProps {
  children: ReactNode;
}

const { REACT_APP_UNSECURE_COOKIE } = process.env;

const ValidateToken = ({ children }: ValidateTokenProps) => {
  const [, setCookie] = useCookies(['token']);

  const [isValid, setIsValid] = useState(false);

  const [searchParams] = useSearchParams();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const { apiGatewayUrl } = useSchool();
  const { setAuth } = useAuth();

  const token = searchParams.get('token') as string;

  useEffect(() => {
    if (token) {
      request<AuthApiResponse>({
        url: '/api/v1/User/Check',
        method: 'get',
        baseURL: apiGatewayUrl,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(({ data }) => {
          const { token, roles } = data;

          const roleIsStudent = roles.find((role) => role.name === 'Student');

          const isMobile = mobileVerify();

          if (isMobile) {
            window.location.href = `melverapp://loginhub/${token.token}`;
          }

          if (roleIsStudent) {
            const unsecureCookie = REACT_APP_UNSECURE_COOKIE === 'true' || window.location.hostname === 'localhost';

            setCookie('token', token.token, {
              path: '/',
              domain: window.location.hostname,
              expires: formatDate(token.expiresAt).toDate(),
              secure: !unsecureCookie,
            });

            setAuth(data);

            navigate(`${pathname}?${URLParams(URLParamsToObject(search, ['token']))}`);
          } else {
            setIsValid(true);
          }
        })
        .catch(() => {
          setIsValid(true);
        });
    } else {
      setIsValid(true);
    }
  }, [token]);

  if (isValid) return <>{children}</>;

  return <Loading label="Por favor, aguarde." />;
};

export default ValidateToken;
